import validUrl from 'valid-url';

export function isValidUrl(url: string) {
  if (validUrl.isUri(url)) {
    return true;
  } else {
    return false;
  }
}

export function urlDomainName(url: string) {
  try {
    const fullHostname = new URL(url).hostname;
    return fullHostname.replace('www.', '');
  } catch (err) {
    console.error(err);
    return null;
  }
}
